import { useEffect, useState } from "react";

export function useBreakpointMatches(breakpoint: number) {
  const mediaQuery = `(min-width: ${breakpoint}px)`;
  const [matches, setMatches] = useState(
    typeof window !== "undefined"
      ? window.matchMedia(mediaQuery).matches
      : false,
  );

  useEffect(() => {
    function handleChange(event: MediaQueryListEvent) {
      setMatches(event.matches);
    }

    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener("change", handleChange);
    return () => {
      mediaQueryList.removeEventListener("change", handleChange);
    };
  }, [mediaQuery]);

  return matches;
}
